function autoCollapser(){

    "use strict";

    var AUTO_COLLAPSE = '.auto_collapse';

    $( AUTO_COLLAPSE ).each(function (index) {
        var children = $( this ).children(),
            arrShow = [],
            arrHide = [];
        for (var i = 0; i < children.length; i++) {
            if(i < 2) {
                arrShow.push(children[i]);
                children[i].remove();
            }
            else {
                arrHide.push(children[i]);
                children[i].remove();
            }
        }
        $('.auto_collapse').append(arrShow);
        $('#more-description').append(arrHide);
    });

}

module.exports = autoCollapser;


// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/components/global/11_auto-collapser.js